import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { DataService } from '../service/data.service';

export enum KeyType {
  ROLE = 'role',
  PERMISSION = 'permission',
  NOTIFICATION = 'notification'
}

@Pipe({
  name: 'xTranslateKey',
  pure: false
})
export class XTranslateKeyPipe implements PipeTransform {

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private translateService: TranslateService,
    protected dataSrv: DataService) {
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  transform(value: string, type: any): string {
    if (type === KeyType.ROLE) {
      return this.dataSrv.getRoleTranslationKey(value);
    } else if (type === KeyType.PERMISSION) {
      return this.dataSrv.getPermissionTranslationKey(value);
    } else if (type === KeyType.NOTIFICATION) {
      return this.dataSrv.getNotificationTranslationKey(value);
    } else {
      return this.translateService.instant('MISC.NOTFOUND');
    }
  }

}
